import { Component, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { VisitorInfoForm } from '../../../models/visitor-info-form.model';

const DEFAULT_FORM_INFO: VisitorInfoForm = Object.freeze({
  name: '',
  email: '',
  degree: 'bachelor',
  major: '',
  gradYear: '',
  jobType: 'fulltime',
  industry: ''
})

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements OnInit {

  @ViewChild('closeBtn') closeBtn: ElementRef;
  formInfo: VisitorInfoForm = Object.assign({}, DEFAULT_FORM_INFO);
  constructor() { }

  ngOnInit() {
  }

  submitForm() {
    this.formInfo = Object.assign({}, DEFAULT_FORM_INFO);
    this.closeModal();
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/carousel/carousel.component.ts